  <div class="legend {inPanel ? 'in-panel' : ''}" bind:this={legendElem}>
    <div class="legend-title" on:click={toggleLegend} bind:this={legendElemDrawer}>
      {#if inPanel}
        <span class="legend-title-drawer"></span>
      {/if}
      <h3><span class="bold">MAP KEY</span> - Depth of flooding in metres</h3>
      {#if !inPanel}
        <div class="legend-title-cta" on:click={closeLegend}>
          <div class="plus-sign"></div>
        </div>
      {/if}
    </div>
    {#if shouldShow}
      <div class="legend-content" transition:slide="{{delay: 250, duration: 300, easing: quintOut }}">
        <ul>
          {#each legendItems as item}
            <li>
              <div class="legend-icon">
                <img src={`data:image/png;base64,${item.imageData}`} alt={item.label}>
              </div>
              <div class="legend-text">{item.label}</div>
            </li>
          {/each}
        </ul>
      </div>
    {/if}  
  </div>




<script>
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { loadModules } from "esri-loader";
import store from "../../state";
import { onMount, createEventDispatcher } from "svelte/internal";
store;
import { slide, fade } from "svelte/transition";
slide;
fade;
import { quintOut } from "svelte/easing";
quintOut;
import { pathOr } from "ramda";
export let activeRegion = undefined;
export let inPanel = false;
const dispatch = createEventDispatcher();
// html data
let shouldShow = true;
let layersWithLegends = [];
let selectedLayerId = null;
let legendElem;
let legendElemDrawer;
//@ts-ignore;
$: legendItems = pathOr([
    {
        label: "Depth N/A",
        imageData: "iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IB2cksfwAAAAlwSFlzAAAOxAAADsQBlSsOGwAAASxJREFUOI2t1DFugzAUBuB/ILVURUqlDB06t+EOrO2WA3CHROIAHcrClg5I4Q4coFs6ZPEdSLuEgaFDRJFQFTceujRPPFIKBP7JelifbD38DPQc47gIHeF2gWxfuQSGjnCF+fw0GE/Yplw+QJhLlOvF7Ldr6MRD6AjYvnLphIPxBJfmPW3MZABhLjGyZpXY98c7tPRg3DxCJwvQCcvJZAAAtdjnyx2upm/QaYy8CmyLXVzfQqcxfWPgOVg5BB4b0AVjYB8YA//7NZpiDOwDqwWbYofdph5simUygIrmAEQ12AYDgKG1Qi6nf4NtsZE1w1f0SnUGnoOVQ+B+u4aWXieMgTr5nRppzN5mMYfdBiqaY2it2DVPumz7yg0dAZ0saGpUR1ADimEDtljomh8Gj77ZG9EItQAAAABJRU5ErkJggg=="
    },
    {
        label: "0-0.3m",
        imageData: "iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IB2cksfwAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAHJJREFUOI1jYaAyYIEx2NnZGygx6OfPnw1wA9nZ2Rt6ex3q1dVFyDLswIH7DD09Zxl+/vzZAHehuroIg4uLCtku7Ok5ywB3ITXBqIGjBo4aOMwMPHDgPtmG3Lz5BtXAnz9/NvT0nIUXQeQAlAIWWYBSAAAj/CTLaj4EGwAAAABJRU5ErkJggg=="
    },
    {
        label: "0.3-0.5m",
        imageData: "iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IB2cksfwAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAHNJREFUOI1jYaAyYIEx2NnZGygx6OfPnw1wA9nZ2Ru8WiTqxVR5yDLs9pF3DEcnv2P4+fNnA9yFYqo8DBqO4mS78OjkdwxwF1ITjBo4auCogcPMwNtH3pFtyKvbX1AN/PnzZ8PRye/gRRA5AKWARRagFAAAIsMl8JFykzIAAAAASUVORK5CYII="
    },
    {
        label: "0.5-1.2m",
        imageData: "iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IB2cksfwAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAG1JREFUOI1jYaAyYIEx2NnZGygx6OfPnw1wA9nZ2RskioTqORT5yDLs9cnXDAxLIIbCXcihyMcgZi5Mtgu/LvnKAHchNcGogaMGjho4zAx8ffI12Yb8uP8J1cCfP382MCxBFEHkAJQCFlmAUgAAbuAi5pz/fCcAAAAASUVORK5CYII="
    },
    {
        label: "1.2-2m",
        imageData: "iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IB2cksfwAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAHhJREFUOI1jYaAyYIEx2NnZGygx6OfPnw1wA9nZ2Ru4Q7zqeaXEyDLsxbXbDOx7jjL8/PmzAe5CXikxBh4dDbIMlGBgYHix5ygD3IXUBKMGjho4auAwM/DFtdsMEmQa8vnZK1QDf/782cC+5yi8CCIHoBSwyAKUAgDlfySbdU/7TwAAAABJRU5ErkJggg=="
    },
    {
        label: "2-4m",
        imageData: "iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IB2cksfwAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAHJJREFUOI1jYaAyYIEx2NnZGygx6OfPnw1wA9nZ2RsYNP3quQXEyTLs65PbDOyPDzD8/PmzAe5CbgFxBl4JbbJd+PXxAQa4C6kJRg0cNXDUwGFm4Ncnt8k25OuHl6gG/vz5s4H98QF4EUQOQClgkQUoBQD1hST2sYBUagAAAABJRU5ErkJggg=="
    },
    {
        label: ">4m",
        imageData: "iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IB2cksfwAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAG1JREFUOI3t1LENgDAQQ1EXkf4C2YAxGI4bMSvQs4A7CpQI6AhUKK6iSPfkykkfJ9UHEG8g29FAIOx5gdyJrYIi23FqmCVNXSBIUlFr+GUGOMAB/gw8JqgPsbd2m44PBxTVCXoauA1sRfv6XbMDUyAhvSDfvCkAAAAASUVORK5CYII="
    }
], ["items"], layersWithLegends.find(x => x.id === selectedLayerId));
onMount(() => __awaiter(void 0, void 0, void 0, function* () {
    if (activeRegion) {
        activeRegion.bind(legendElemDrawer, "tap", (evt) => {
            toggleLegend();
        });
        activeRegion.bind(legendElem, "swipe", (evt) => {
            const directionDegree = evt.detail.data[0].currentDirection;
            //For swipe up and down only
            // up 90deg, down 270deg, buffer +- 68 deg
            if (directionDegree >= 22 && directionDegree <= 157) {
                !shouldShow && toggleLegend();
            }
            if (directionDegree >= 202 && directionDegree <= 337) {
                shouldShow && toggleLegend();
            }
        });
    }
    // loadLegend();
}));
const floodLayerToggleListener = (state) => {
    const mapViewService = state.mapViewService;
    if (state.mapViewService.isReady()) {
        try {
            const layer = mapViewService.getVisibleFloodLayer();
            if (layer && layer.selectedFloodLayer) {
                selectedLayerId = layer.selectedFloodLayer.id;
            }
        }
        catch (e) {
            console.error(e);
        }
    }
};
function loadLegend() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const [request] = yield loadModules(["esri/request"]);
            // @ts-ignore
            const mapViewSvc = $store.mapViewService;
            const layers = yield mapViewSvc.getAllLayers();
            // @ts-ignore
            const token = $store.token;
            const requestLegendJson = (l, layerName) => __awaiter(this, void 0, void 0, function* () {
                const { data } = yield request(`${l.url}/legend?f=pjson&token=${token}`, {
                    responseType: "json"
                });
                return {
                    id: l.id,
                    legend: data.layers.find((l) => l.layerName === layerName).legend
                };
            });
            const getLegends = (items) => __awaiter(this, void 0, void 0, function* () {
                return yield Promise.all(items.map((layer) => requestLegendJson(layer, "Flood depth")));
            });
            const legendData = yield getLegends(layers.filter((l) => l.title.indexOf("flood") > -1));
            layersWithLegends = layers
                .filter((l) => l.title.indexOf("flood") > -1)
                .map(({ id }, i) => {
                const layerLegend = legendData.find((l) => l.id === id);
                if (layerLegend) {
                    return {
                        id,
                        items: layerLegend.legend
                    };
                }
            })
                .filter((l) => l);
            selectedLayerId = layersWithLegends[0].id;
        }
        catch (e) {
            console.error(e);
        }
    });
}
function toggleLegend() {
    if (inPanel) {
        shouldShow = !shouldShow;
    }
}
function closeLegend() {
    dispatch("close");
}
</script>


<style>.legend{background-color:#fff;width:100%;background:linear-gradient(180deg,#fff 70%,#d7d7d7);box-shadow:0 -2px 4px 0 rgba(0,0,0,.2)}.legend-title{height:41px;border-bottom:1px solid #c8c8c8;padding:16px 10px 0;position:relative;display:flex;justify-content:space-between;align-items:center}.legend-title h3{font-size:.875rem;font-family:AvenirLT-Medium;font-weight:700}.legend-title h3 .bold{font-family:AvenirLT-Black}.legend-title-cta .plus-sign{transform:rotate(45deg)}.legend-title-cta .plus-sign:after,.legend-title-cta .plus-sign:before{background-color:#9e9e9e}.legend.in-panel{margin-bottom:48px}.legend.in-panel .legend-title{cursor:pointer;flex-direction:column;justify-content:flex-start;align-items:flex-start}.legend.in-panel .legend-title-drawer{display:block;height:3px;width:24px;background-color:hsla(0,0%,78.4%,.8);position:absolute;top:6px;left:calc(50% - 12px)}.legend-content{padding:16px 0;height:66px;position:relative;overflow:hidden}.legend-content ul{display:flex;font-size:9px;line-height:12px;justify-content:space-around}.legend-content ul li{text-align:center;width:45px}.legend-content ul li img{height:20px;width:20px;opacity:.5}@media screen and (min-width:768px){.legend{position:absolute;bottom:0;left:0;z-index:1}}</style>
